import { CustomButton } from 'components/shared/CustomButton'
import { CustomTextBox } from 'components/shared/CustomTextBox'
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardFooter, Col, Container, Form, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import { Formik, FormikErrors, useFormik } from "formik";
import * as Yup from "yup";
import { CustomDatePicker } from 'components/shared/CustomDatePicker';
import { CustomTextArea } from 'components/shared/CustomTextArea';
import 'react-quill/dist/quill.snow.css';
import RichTextEditor from 'components/ReactQuile';
import moment from 'moment';
import CommonService from 'services/CommonService';
import MasterService from 'services/Master.Service';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { CustomImageUpload } from 'components/shared/CustomImageUpload';
import CustomLoader from 'components/Common/CustomLoader';
import { CustomToaster } from 'components/shared/CustomToaster';
import { loadConfigforImageCdnUrl } from 'helpers/Helper';
interface QuestionAnswer {
    question: string;
    answer: string;
    Active: boolean
    Id?: number;
    BlogId?: number
}
type Param = {
    routeId: any
}

interface MaxLengths {
    Question_Max_Length: number;
    Answer_Max_Length: number;
    Description_Max_Length: number;
    Max_Name_Length: number;
    Max_Title_Length: number;
    Max_Image_Title_Length: number;
    Max_Image_Alt_Length: number;
    Max_Facebook_Length: number;
    Max_linkedIn_Length: number;
    Max_XPath_Length: number;
    MetaDescription_Max_Length: number,
    URL_Title_Max_Length: number,
}


function BlogCreateEdit() {

    const [lengths, setLengths] = useState<MaxLengths>({
        Question_Max_Length: 200,
        Answer_Max_Length: 500,
        Description_Max_Length: 1000,
        Max_Name_Length: 1000,
        Max_Title_Length: 1000,
        Max_Image_Title_Length: 1000,
        Max_Image_Alt_Length: 1000,
        Max_Facebook_Length: 1000,
        Max_linkedIn_Length: 1000,
        Max_XPath_Length: 1000,
        MetaDescription_Max_Length: 200,
        URL_Title_Max_Length: 100,
    })
    const getConfig = async () => {
        let config = await fetch('/config.json');
        let data = await config.json();
        setLengths(data.Config)
    }

    useEffect(() => {
        getConfig();
    }, [])

    const [cdnUrl, setCdnUrl] = useState("");
    const { routeId } = useParams<Param>();
    const [apiResMsg, setapiRes] = useState<string>("");
    const [toast, setToast] = useState(false);
    const [btnDisable, setBtnDisable] = useState(false)
    const [displayInList, setDisplayInList] = useState(true)
    const [dltModal, setDltModal] = useState(0);
    const [blogActive, setBlogActive] = useState(true)
    const [editForm, setEditForm] = useState(false)
    const [imgName, setImg] = useState('')
    const [editPageImg, setEditPageImg] = useState(false)
    const [imgBlob, setImgBlob] = useState<Blob | null>(null);
    const [StatsName, setStatsName] = useState("")
    const [CreatedBy, setCreatedBy] = useState(0)
    const [faqList, setFaqList] = useState<QuestionAnswer[]>([]);
    const [load, setLoad] = useState<boolean>(false);
    const [fieldDisable, setFieldDisable] = useState<boolean>(false)
    const [remainingCharacters, setRemainingCharacters] = useState<number[]>([]);
    const [ansRemainingCharacters, setAnsRemainingCharacters] = useState<number[]>([]);
    const [remainingDescription, setRemainingDescription] = useState(lengths?.Description_Max_Length);


    const formik = useFormik({
        enableReinitialize: false,
        initialValues: {
            Name: "",
            TitleOfThePage: "",
            EditionDate: moment().format("YYYY-MM-DD"),
            ImagePath: imgName,
            ImageAltName: '',
            ImageTitleName: "",
            ShortDescription: '',
            ContentDetails: "",
            LinkedInPath: "",
            XPath: "",
            FacebookPath: "",
            SchemaContent: '',
            DisplayInList: displayInList,
            StatusName: StatsName,
            faqList: faqList,
            UploadFiles: imgBlob,
            Active: blogActive,
            Qustion: '',
            Answer: '',
            CreatedBy: CreatedBy,
            MetaDescription: '',
            URLTitle: ""

        },
        validationSchema: Yup.object({
            Name: Yup.string().required("Please Enter Blog Name").max(lengths?.Max_Name_Length, `Name cannot exceed ${lengths?.Max_Name_Length} characters`).nullable(),
            TitleOfThePage: Yup.string().required("Please Enter The Page Title").nullable(),
            ImageTitleName: Yup.string().required("Please Enter The Image Title Name").nullable(),
            ImageAltName: Yup.string().required("Please Enter The Image Alt Name").nullable(),
            ImagePath: Yup.string().required("Please Upload Image").nullable(),
            ShortDescription: Yup.string().required("Please Enter The ShortDescription").nullable(),
            ContentDetails: Yup.string().required("Please Enter The ContentDetails").nullable(),
            URLTitle: Yup.string().required("Please Enter URL Title").nullable(),
            faqList: Yup.array().of(
                Yup.object({
                    question: Yup.string().required('Question is required'),
                    answer: Yup.string().required('Answer is required')
                })
            )
        }),

        onSubmit: async (values, { setErrors, setSubmitting }) => {
            setBtnDisable(true)
            setLoad(true)
            createUser(values)
        }
    })

    const addFAQ = () => {
        if (faqList.length < 5) {
            if (routeId) {
                const newFAQ = { question: '', answer: '', Active: true, BlogId: routeId };
                const updatedFaqList = [...faqList, newFAQ];
                setFaqList(updatedFaqList);
                formik.setFieldValue('faqList', updatedFaqList);
            } else {
                const newFAQ = { question: '', answer: '', Active: true };
                const updatedFaqList = [...faqList, newFAQ];
                setFaqList(updatedFaqList);
                formik.setFieldValue('faqList', updatedFaqList);
            }

        }
    }
    const removeFAQ = (indexToRemove: number) => {
        const updatedFaqList = faqList.filter((_, index) => index !== indexToRemove);
        setFaqList(updatedFaqList);
        formik.setFieldValue('faqList', updatedFaqList);

    }
    const removeAllFAQ = () => {
        setFaqList([]);
        formik.setFieldValue('faqList', []);
    }
    const handleDeleteBlog = () => {
        setBlogActive(false);
        formik.setFieldValue("Active", false);
        formik.handleSubmit();
        setDltModal(0)
    };

    function createUser(data: any) {
        if (editForm) {
            let formData = new FormData();
            formData.append("Id", routeId);
            formData.append("Name", data.Name);
            formData.append("TitleOfThePage", data.TitleOfThePage);
            formData.append("EditionDate", data.EditionDate);
            formData.append("imagePath", data.ImagePath);
            formData.append("ImageAltName", data.ImageAltName);
            formData.append("ImageTitleName", data.ImageTitleName);
            formData.append("ShortDescription", data.ShortDescription);
            formData.append("ContentDetails", data.ContentDetails);
            formData.append("LinkedInPath", data.LinkedInPath);
            formData.append("XPath", data.XPath);
            formData.append("FacebookPath", data.FacebookPath);
            formData.append("DisplayInList", data.DisplayInList);
            formData.append("StatusName", data.StatusName);
            formData.append("Active", data.Active);
            formData.append("UploadFiles", data.UploadFiles);
            formData.append("SchemaContent", data.SchemaContent);
            formData.append("RawBlogFAQ", JSON.stringify(data.faqList));
            formData.append("BlogFAQ", JSON.stringify(data.faqList));
            formData.append("CreatedBy", data.CreatedBy)
            formData.append("MetaDescription", data.MetaDescription)
            formData.append("URLTitle", data.URLTitle.replace(/ /g, "-"))
            CommonService.postWithFormData("Blog", "BlogUpdate", formData).then(res => {
                if (res.status === 200) {
                    if (res.data > 0) {
                        setToast(true)
                        setapiRes("Update successfully")
                        if (StatsName !== "Draft" && StatsName !== "UnPublished") {
                            window.location.href = "/blogs";
                        }
                        setLoad(false)
                        setBtnDisable(false)
                    } else {
                        setToast(true)
                        setapiRes("URL title already present")
                        formik.setFieldError("URLTitle", "URL title already present")
                        setLoad(false)
                        setBtnDisable(false)
                    }
                    setBtnDisable(false)
                }
            }).catch(e => {
                setToast(true)
                setapiRes(e)
                console.error('Error:', e);
            });
        } else {

            let formData = new FormData();
            formData.append("Name", data.Name);
            formData.append("TitleOfThePage", data.TitleOfThePage);
            formData.append("EditionDate", data.EditionDate);
            formData.append("imagePath", data.ImagePath);
            formData.append("ImageAltName", data.ImageAltName);
            formData.append("ImageTitleName", data.ImageTitleName);
            formData.append("ShortDescription", data.ShortDescription);
            formData.append("ContentDetails", data.ContentDetails);
            formData.append("LinkedInPath", data.LinkedInPath);
            formData.append("XPath", data.XPath);
            formData.append("FacebookPath", data.FacebookPath);
            formData.append("DisplayInList", data.DisplayInList);
            formData.append("StatusName", data.StatusName);
            formData.append("Active", data.Active);
            formData.append("UploadFiles", data.UploadFiles);
            formData.append("SchemaContent", data.SchemaContent);
            formData.append("RawBlogFAQ", JSON.stringify(data.faqList));
            formData.append("BlogFAQ", JSON.stringify(data.faqList));
            formData.append("MetaDescription", data.MetaDescription)
            formData.append("URLTitle", data.URLTitle.replace(/ /g, "-"))
            CommonService.postWithFormData("Blog", "BlogPost", formData).then(res => {
                if (res.status === 200) {
                    if (res.data > 0) {
                        setToast(true)
                        setapiRes("Create successfully")
                        window.location.href = "/blogs";
                        setLoad(false)
                    } else {
                        setToast(true)
                        formik.setFieldError("URLTitle", "URL title already present")
                        setapiRes("URL title already present")
                        setFieldDisable(false)
                    }
                }

            }).catch(e => {
                setToast(true)
                setapiRes(e)
                console.error('Error:', e);
            });
        }
    }
    const onGetBlog = (Id: number) => {
        MasterService.GetBlog(Id).then(res => {
            setLoad(true)
            if (res.status === 200) {
                if (res.data.StatusName == "Published") {
                    setFieldDisable(true)
                }
                const blogFAQs = res.data.BlogFAQ || [];
                const faqList = blogFAQs.map((faq: any) => ({
                    BlogId: faq.BlogId,
                    Id: faq.Id,
                    Active: faq.Active,
                    question: faq.Question || "",
                    answer: faq.Answer || "",
                }));
                setFaqList(faqList)
                const mappedValues = {
                    Name: res.data.Name || "",
                    TitleOfThePage: res.data.TitleOfThePage || "",
                    EditionDate: moment(res.data.EditionDate).format("YYYY-MM-DD"),
                    ImagePath: res.data.ImagePath || "",
                    ImageAltName: res.data.ImageAltName || "",
                    ImageTitleName: res.data.ImageTitleName || "",
                    ShortDescription: res.data.ShortDescription || "",
                    ContentDetails: res.data.ContentDetails || "",
                    LinkedInPath: res.data.LinkedInPath || "",
                    XPath: res.data.XPath || "",
                    FacebookPath: res.data.FacebookPath || "",
                    DisplayInList: res.data.DisplayInList,
                    StatusName: res.data.StatusName,
                    faqList,
                    UploadFiles: res.data.UploadFiles || "",
                    Active: res.data.Active,
                    Qustion: res.data?.Question || "",
                    Answer: res.data?.Answer || "",
                    Created: res.data.Created || "",
                    Modified: res.data.Modified || "",
                    CreatedBy: res.data.CreatedBy || "",
                    ModifiedBy: res.data.ModifiedBy || "",
                    SchemaContent: res.data.SchemaContent || "",
                    MetaDescription: res.data.MetaDescription || "",
                    URLTitle: res.data.URLTitle.replace(/-/g, " ") || "",
                };
                setCreatedBy(res.data.CreatedBy)
                formik.setValues(mappedValues)

                formik.setFieldValue("DisplayInList", res.data.DisplayInList)
                formik.validateForm();
                setLoad(false)
                setEditPageImg(true)
            }
        }).catch(e => {
            console.log(e);
        });
    }
    const handleDescriptionChange = (e) => {
        const { value } = e.target;
        if (value.length <= lengths?.Description_Max_Length) {
            formik.handleChange(e);
            setRemainingDescription(lengths?.Description_Max_Length - value.length);
        }
    };
    useEffect(() => {
        if (routeId != undefined || routeId != null) {
            onGetBlog(routeId);
            setEditForm(true)
        } else {
            setEditForm(false)
        }
    }, [routeId]);
    const handleSubmit = async (value) => {
        const errors = await formik.validateForm();
        if (Object.keys(errors).length > 0) {
            return;
        }
        if (value == "UnPublished") {
            setFieldDisable(false)
            setDisplayInList(false)
            formik.setFieldValue("StatusName", value)
            formik.setFieldValue("DisplayInList", false)
        }
        if (value == "Published") {
            setDisplayInList(true)
            formik.setFieldValue("StatusName", value)
            formik.setFieldValue("DisplayInList", true)
        }
        if (value == "Draft") {
            setDisplayInList(true)
            formik.setFieldValue("StatusName", value)
            formik.setFieldValue("DisplayInList", true)
        }
        setStatsName(value)
        formik.setFieldValue("StatusName", value)
        if (editForm == true) {
            formik.handleSubmit();
        }
    };

    const handleImageChange = (fileName, fileSize, file) => {
        const maxSize = 2 * 1024 * 1024;
        if (fileSize > maxSize) {
            formik.setFieldError("ImagePath", "File size exceeds 2MB.");
            return;
        }
        if (file) {
            const fileWithMeta = new File([file], fileName, { type: file.type });
            const previewUrl = URL.createObjectURL(fileWithMeta);
            const img = new Image();
            img.src = previewUrl;
            img.onload = () => {
                const minWidth = 480;
                const maxWidth = 500;
                const minHeight = 250;
                const maxHeight = 270;
                if (img.width >= minWidth && img.width <= maxWidth &&
                    img.height >= minHeight && img.height <= maxHeight
                ) {
                    formik.setFieldError("ImagePath", "");
                    formik.setFieldTouched("ImagePath", false)
                    formik.setFieldValue("ImagePath", fileName)
                    formik.setFieldValue("UploadFiles", fileWithMeta)
                    setImg(previewUrl);
                    setImgBlob(fileWithMeta);
                } else {
                    formik.setFieldError("ImagePath", `Image dimensions should be Width:${minWidth}-${maxWidth}, Height:${minHeight}-${maxHeight}.`);
                    return;
                }
            }
        }
    }
    const handleImageDelete = () => {
        setImg('');
        setImgBlob(null);
    };
    const editPageImgDelete = () => {
        setEditPageImg(false)
        formik.setFieldValue("ImagePath", "")
        setImg('');
        setImgBlob(null);
    }
    const handleFAQChange = (index: number, field: "question" | "answer", value: string) => {
        const updatedList = [...faqList];
        if (field === "question" && value.length <= lengths?.Question_Max_Length) {
            updatedList[index][field] = value;
            setRemainingCharacters((prev) => {
                const updatedCount = [...prev];
                updatedCount[index] = lengths?.Question_Max_Length - value.length;
                return updatedCount;
            });
        }
        else if (field === "answer" && value.length <= lengths?.Answer_Max_Length) {
            updatedList[index][field] = value;
            setAnsRemainingCharacters((prev) => {
                const updatedCount = [...prev];
                updatedCount[index] = lengths?.Answer_Max_Length - value.length;
                return updatedCount;
            });
        }
        //updatedList[index][field] = value;
        setFaqList(updatedList);
        formik.setFieldValue(`faqList[${index}].${field}`, value);
    };

    useEffect(() => {
        const fetchCdnUrl = async () => {
            const url = await loadConfigforImageCdnUrl();
            setCdnUrl(url);
        };
        fetchCdnUrl();
    }, []);

    return (
        <div className='page-content'>
            <Form onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
                return false;
            }}>
                <Container fluid>
                    <div>
                        <h5 className="d-flex mb-3 fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>{editForm ? "EDIT BLOG" : "CREATE BLOG"}</h5>
                    </div>
                    <Card>
                        <CardBody>
                            <Form onSubmit={formik.handleSubmit}>
                                <Row>
                                    <Col xl={8}>
                                        <CustomTextBox
                                            name="Name"
                                            label="Name"
                                            id={"Name"}
                                            customMaxLength={lengths?.Max_Name_Length}
                                            value={formik.values.Name}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.Name && formik.errors.Name ? true : false}
                                            error={formik.errors.Name}
                                            onChange={(e) => {
                                                if (e.target.value.length <= lengths?.Max_Name_Length) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            // placeholder={""}
                                            isMandatory={true}
                                            disabled={fieldDisable} />
                                    </Col>
                                    <Col xl={4}>
                                        <CustomTextBox
                                            name="TitleOfThePage"
                                            label="Page Title"
                                            id={"TitleOfThePage"}
                                            customMaxLength={lengths?.Max_Title_Length}
                                            value={formik.values.TitleOfThePage}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.TitleOfThePage && formik.errors.TitleOfThePage ? true : false}
                                            error={formik.errors.TitleOfThePage}
                                            onChange={(e) => {
                                                if (e.target.value.length <= lengths?.Max_Title_Length) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            // placeholder={""}
                                            isMandatory={true}
                                            disabled={fieldDisable} />
                                    </Col>
                                    <Col xl={12}>
                                        <CustomTextBox
                                            name="URLTitle"
                                            label="URL Title"
                                            id={"URLTitle"}
                                            customMaxLength={lengths?.URL_Title_Max_Length}
                                            value={formik.values.URLTitle}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.URLTitle && formik.errors.URLTitle ? true : false}
                                            error={formik.errors.URLTitle}
                                            onChange={(e) => {
                                                if (e.target.value.length <= lengths?.URL_Title_Max_Length) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            // placeholder={""}
                                            isMandatory={true}
                                            disabled={fieldDisable} />
                                    </Col>
                                    <Col xl={12}>
                                        <CustomTextArea
                                            name="ShortDescription"
                                            label="Short Description"
                                            id={"ShortDescription"}
                                            value={formik.values.ShortDescription}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.ShortDescription && formik.errors.ShortDescription ? true : false}
                                            error={formik.errors.ShortDescription}
                                            onChange={handleDescriptionChange}
                                            // placeholder={""}
                                            isMandatory={true}
                                            disabled={fieldDisable} />
                                        <div className={`text-xs ${remainingDescription <= 0 ? 'text-danger' : 'text-black-500'}`}>
                                            {remainingDescription >= 0
                                                ? `${remainingDescription} characters remaining`
                                                : `Exceeded by ${Math.abs(remainingDescription)} characters`}
                                        </div>

                                    </Col>
                                    <Col xl={12}>
                                        <CustomTextArea
                                            name="MetaDescription"
                                            label="Meta Description"
                                            id={"MetaDescription"}
                                            customMaxLength={lengths?.MetaDescription_Max_Length}
                                            value={formik.values.MetaDescription}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.MetaDescription && formik.errors.MetaDescription ? true : false}
                                            error={formik.errors.MetaDescription}
                                            onChange={(e) => {
                                                if (e.target.value.length <= lengths?.MetaDescription_Max_Length) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            // placeholder={""}
                                            isMandatory={false}
                                            disabled={fieldDisable} />

                                    </Col>
                                    <Col xl={4}>
                                        {editPageImg == true ?
                                            <>
                                                <Label className="mt-3 mb-1">Image</Label>
                                                <div>
                                                    <div className="thumbInner">
                                                        <img
                                                            style={{ height: 100 }}
                                                            // src={editPageImg}
                                                            src={`${cdnUrl}/blog/${routeId}/${formik.values.ImagePath}`}
                                                            className={"circular-profile-image"}
                                                        />
                                                        {fieldDisable == false &&
                                                            <div className="delete-icon">
                                                                <i className="mdi mdi-close-circle-outline" onClick={editPageImgDelete} /> {formik.values.ImagePath}
                                                            </div>
                                                        }
                                                    </div>
                                                </div> </> :
                                            <CustomImageUpload validateMessage={true} label={"Image"} name={"ImagePath"} onBlur={formik.handleBlur} invalid={formik.touched.ImagePath && formik.errors.ImagePath ? true : false} onImageDelete={handleImageDelete} id={"ImagePath"} placeholder={"Upload Image"} value={imgBlob} error={formik.errors.ImagePath} isMandatory={true} onFileSelected={handleImageChange} />

                                        }</Col>
                                    <Col xl={4}>
                                        <CustomTextBox
                                            name="ImageTitleName"
                                            label="Image Title Name"
                                            id={"ImageTitleName"}
                                            customMaxLength={lengths?.Max_Image_Title_Length}
                                            value={formik.values.ImageTitleName}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.ImageTitleName && formik.errors.ImageTitleName ? true : false}
                                            error={formik.errors.ImageTitleName}
                                            onChange={(e) => {
                                                if (e.target.value.length <= lengths?.Max_Image_Title_Length) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            // placeholder={""}
                                            isMandatory={true}
                                            disabled={fieldDisable} />
                                    </Col>
                                    <Col xl={4}>
                                        <CustomTextBox
                                            name="ImageAltName"
                                            label="Image Alt Name"
                                            id={"ImageAltName"}
                                            customMaxLength={lengths?.Max_Image_Alt_Length}
                                            value={formik.values.ImageAltName}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.ImageAltName && formik.errors.ImageAltName ? true : false}
                                            error={formik.errors.ImageAltName}
                                            onChange={(e) => {
                                                if (e.target.value.length <= lengths?.Max_Image_Alt_Length) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            // placeholder={""}
                                            isMandatory={true}
                                            disabled={fieldDisable} />
                                    </Col>
                                    <Col xl={4}>
                                        <CustomTextBox
                                            name="LinkedInPath"
                                            label="LinkedIn Path"
                                            id={"LinkedInPath"}
                                            customMaxLength={lengths?.Max_linkedIn_Length}
                                            value={formik.values.LinkedInPath}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.LinkedInPath && formik.errors.LinkedInPath ? true : false}
                                            error={formik.errors.LinkedInPath}
                                            onChange={(e) => {
                                                if (e.target.value.length <= lengths?.Max_linkedIn_Length) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            // placeholder={""}
                                            isMandatory={false}
                                            disabled={fieldDisable} />
                                    </Col>


                                    <Col xl={4}>
                                        <CustomTextBox
                                            name="FacebookPath"
                                            label="Facebook Path"
                                            id={"FacebookPath"}
                                            customMaxLength={lengths?.Max_Facebook_Length}
                                            value={formik.values.FacebookPath}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.FacebookPath && formik.errors.FacebookPath ? true : false}
                                            error={formik.errors.FacebookPath}
                                            onChange={(e) => {
                                                if (e.target.value.length <= lengths?.Max_Facebook_Length) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            // placeholder={""}
                                            isMandatory={false}
                                            disabled={fieldDisable} />
                                    </Col>
                                    <Col xl={4}>
                                        <CustomTextBox
                                            name="XPath"
                                            label="X Path"
                                            customMaxLength={lengths?.Max_XPath_Length}
                                            id={"XPath"}
                                            value={formik.values.XPath}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.XPath && formik.errors.XPath ? true : false}
                                            error={formik.errors.XPath}
                                            onChange={(e) => {
                                                if (e.target.value.length <= lengths?.Max_XPath_Length) {
                                                    formik.handleChange(e);
                                                }
                                            }}
                                            // placeholder={""}
                                            isMandatory={false}
                                            disabled={fieldDisable} />

                                    </Col>
                                    <Col xl={12}>
                                        <CustomTextArea
                                            name="SchemaContent"
                                            label="Schema Content"
                                            id={"SchemaContent"}
                                            value={formik.values.SchemaContent}
                                            onBlur={formik.handleBlur}
                                            invalid={formik.touched.SchemaContent && formik.errors.SchemaContent ? true : false}
                                            error={formik.errors.SchemaContent}
                                            onChange={
                                                formik.handleChange}
                                            // placeholder={""}
                                            isMandatory={false}
                                            disabled={fieldDisable} />
                                    </Col>
                                    <Col xl={4}>
                                        <CustomDatePicker
                                            label={"Edition Date"}
                                            value={formik.values.EditionDate}
                                            disabled={true}
                                            onChange={(e: any) => formik.setFieldValue("EditionDate", e.target.value)} name={"EditionDate"} id={"EditionDate"} error={Error}
                                        />
                                    </Col>
                                    <Col xl={12}>
                                        <label className="mt-3 mb-0 form-label">Content Details <span style={{ color: 'red' }}>*</span></label>
                                        <RichTextEditor
                                            disabled={fieldDisable}
                                            values={formik.values.ContentDetails}
                                            setValue={(content) => {
                                                formik.setFieldValue("ContentDetails", content);
                                                formik.validateField("ContentDetails");
                                            }}
                                            onBlur={() => formik.setFieldTouched("ContentDetails", true)}
                                            error={formik.touched.ContentDetails && formik.errors.ContentDetails ? formik.errors.ContentDetails : undefined}
                                            invalid={formik.touched.ContentDetails && !!formik.errors.ContentDetails}
                                        />
                                    </Col>

                                </Row>
                            </Form>
                            <div className="d-flex align-items-center justify-content-between border-bottom pb-2">
                                <h5 className="fw-semibold text-dofy dofy-admin-font-md m-0">FAQ</h5>
                                <div className="d-flex gap-2">
                                    {fieldDisable == false && (<>
                                        {(faqList.length <= 0) && <button type="button" onClick={() => addFAQ()} className={`btn btn-outline-primary btn-sm btn-sm w-xs`} >Add </button>}
                                        {faqList.length > 0 && (<button type="button" onClick={removeAllFAQ} className={`btn btn-outline-danger btn-sm w-xs`} > Remove All</button>)}
                                    </>)}
                                </div>
                            </div>
                            <Card>

                                {faqList && faqList.map((faq, index) => (
                                    <CardBody key={index} className="p-0">
                                        <Row>
                                            <Col xl={12}>
                                                <CustomTextArea
                                                    disabled={fieldDisable}
                                                    name={`faqList[${index}].question`}
                                                    customMaxLength={lengths?.Question_Max_Length}
                                                    label={`Question ${index + 1}`}
                                                    value={faq.question}
                                                    onBlur={formik.handleBlur}
                                                    invalid={formik.touched.faqList?.[index]?.question && !!formik.errors.faqList?.[index]}
                                                    error={(formik.errors.faqList && (formik.errors.faqList as FormikErrors<QuestionAnswer[]>)?.[index]?.question) || ""}
                                                    onChange={(e) => {
                                                        if (e.target.value.length <= lengths?.Question_Max_Length) {
                                                            handleFAQChange(index, "question", e.target.value);
                                                        }
                                                    }}
                                                    isMandatory={true} id={undefined} />

                                                <div className={`text-xs ${(remainingCharacters[index] ?? lengths?.Question_Max_Length) <= 0 ? 'text-danger' : 'text-black-500'}`}>
                                                    {(remainingCharacters[index] ?? lengths?.Question_Max_Length) >= 0
                                                        ? `${remainingCharacters[index] ?? lengths?.Question_Max_Length} characters remaining`
                                                        : `Exceeded by ${Math.abs(remainingCharacters[index] ?? lengths?.Question_Max_Length)} characters`}
                                                </div>
                                            </Col>
                                            <Col xl={12}>
                                                <CustomTextArea
                                                    disabled={fieldDisable}
                                                    customMaxLength={lengths?.Answer_Max_Length}
                                                    name={`faqList[${index}].answer`}
                                                    label={`Answer ${index + 1}`}
                                                    value={faq.answer}
                                                    onBlur={formik.handleBlur}
                                                    invalid={formik.touched.faqList?.[index]?.answer && formik.errors.faqList?.[index]}
                                                    error={(formik.errors.faqList && (formik.errors.faqList as FormikErrors<QuestionAnswer[]>)?.[index]?.answer) || ""}
                                                    onChange={(e) => handleFAQChange(index, "answer", e.target.value)}
                                                    isMandatory={true} id={undefined} />
                                                <div className={`text-xs ${(ansRemainingCharacters[index] ?? lengths?.Answer_Max_Length) <= 0 ? 'text-danger' : 'text-black-500'}`}>
                                                    {(ansRemainingCharacters[index] ?? lengths?.Answer_Max_Length) >= 0
                                                        ? `${ansRemainingCharacters[index] ?? lengths?.Answer_Max_Length} characters remaining`
                                                        : `Exceeded by ${Math.abs(ansRemainingCharacters[index] ?? lengths?.Answer_Max_Length)} characters`}
                                                </div>
                                            </Col>
                                            <div className="d-flex justify-content-end gap-2 my-3">
                                                {fieldDisable == false && (<>
                                                    <button type="button" onClick={() => addFAQ()} className={`btn btn-outline-primary btn-sm btn-sm w-xs`} >Add </button>
                                                    <button type="button" onClick={() => removeFAQ(index)} className={`btn btn-outline-danger btn-sm w-xs`} > Remove</button>
                                                </>)}</div>
                                        </Row>
                                    </CardBody>
                                ))}
                                {!editForm ?
                                    <div className="d-flex gap-2 justify-content-end align-items-center mt-3">
                                        <CustomButton
                                            type="submit"
                                            disabled={btnDisable}
                                            btnClassName="btn btn-light btn-sm"
                                            iconClasssName="mdi mdi-content-save font-size-14"
                                            name="Save"
                                            onClick={() => handleSubmit("Draft")}
                                        />
                                        <CustomButton
                                            type="submit"
                                            disabled={btnDisable}
                                            onClick={() => handleSubmit("Published")}
                                            btnClassName="btn btn-success btn-sm"
                                            iconClasssName="mdi mdi-arrow-up-bold font-size-14"
                                            name="Publish"
                                        />
                                        <CustomButton
                                            type="button"
                                            btnClassName="btn btn-Primary btn-sm"
                                            iconClasssName="mdi mdi-arrow-left font-size-14"
                                            name="Back to List"
                                            onClick={() => { window.location.href = "/blogs" }}
                                        />
                                    </div>
                                    :
                                    <div className="d-flex justify-content-end gap-2 align-items-center mt-3">
                                        {(formik.values.StatusName == "UnPublished") &&
                                            (<span className="d-flex justify-content-end gap-2 align-items-center">
                                                <CustomButton
                                                    type="submit"
                                                    disabled={btnDisable}
                                                    btnClassName="btn btn-light btn-sm"
                                                    iconClasssName="mdi mdi-content-save font-size-14"
                                                    name="Save"
                                                    onClick={() => handleSubmit("UnPublished")}
                                                />
                                                <CustomButton
                                                    type="submit"
                                                    disabled={btnDisable}
                                                    onClick={() => handleSubmit("Published")}
                                                    btnClassName="btn btn-success btn-sm"
                                                    iconClasssName="mdi mdi-arrow-up-bold font-size-14"
                                                    name="Publish"
                                                />
                                                <CustomButton
                                                    type="button"
                                                    disabled={btnDisable}
                                                    btnClassName="btn btn-danger btn-sm"
                                                    iconClasssName="mdi mdi-delete font-size-14"
                                                    name="Delete"
                                                    onClick={() => setDltModal(1)}
                                                /></span>)}
                                        {(formik.values.StatusName == "Published") && <span className="d-flex justify-content-end gap-3 align-items-center">
                                            <CustomButton
                                                type="button"
                                                disabled={btnDisable}
                                                onClick={() => handleSubmit("UnPublished")}
                                                btnClassName="btn btn-warning btn-sm"
                                                iconClasssName="mdi mdi-arrow-down-bold font-size-14"
                                                name="UnPublish"
                                            />
                                        </span>}
                                        {/* {(formik.values.StatusName == "Published") && <span className="d-flex justify-content-end gap-3 align-items-center">
                                            <CustomButton
                                                type="button"
                                                disabled={btnDisable}
                                                onClick={handleSubmit("UnPublished")}
                                                btnClassName="btn btn-warning btn-sm"
                                                iconClasssName="mdi mdi-arrow-down-bold font-size-14"
                                                name="UnPublish"
                                            />
                                        </span>} */}
                                        {(formik.values.StatusName == "Draft") && (<span className="d-flex justify-content-end gap-3 align-items-center">

                                            <CustomButton
                                                type="submit"
                                                disabled={btnDisable}
                                                btnClassName="btn btn-light btn-sm"
                                                iconClasssName="mdi mdi-content-save font-size-14"
                                                name="Save"
                                                onClick={() => handleSubmit("Draft")}
                                            />  <CustomButton
                                                type="submit"
                                                disabled={btnDisable}
                                                onClick={() => handleSubmit("Published")}
                                                btnClassName="btn btn-success btn-sm"
                                                iconClasssName="mdi mdi-arrow-up-bold font-size-14"
                                                name="Publish"
                                            />
                                            <CustomButton
                                                type="button"
                                                disabled={btnDisable}
                                                btnClassName="btn btn-danger btn-sm"
                                                iconClasssName="mdi mdi-delete font-size-14"
                                                name="Delete"
                                                onClick={() => setDltModal(1)}
                                            />
                                        </span>)}

                                        <CustomButton
                                            type="button"
                                            btnClassName="btn btn-Primary btn-sm"
                                            iconClasssName="mdi mdi-arrow-left font-size-14"
                                            name="Back to List"
                                            onClick={() => { window.location.href = "/blogs" }}
                                        />
                                    </div>
                                }
                            </Card>

                        </CardBody>
                    </Card>
                    <Modal isOpen={dltModal > 0} toggle={() => setDltModal(0)} centered={true} backdrop size={"sm"}>
                        <div className="modal-content p-0">
                            <ModalBody className="px-2 py-5 text-center">
                                <div className="avatar-sm mb-4 mx-auto">
                                    <div className={" bg-danger avatar-title text-primary bg-opacity-10 fs-1 rounded-3"}>
                                        <i className={`bx bx-error text-danger`}></i>
                                    </div>
                                </div>
                                <p className="text-muted font-size-14 mb-4">Are you sure you want to permanently delete this blog's admin and public sides?</p>

                                <div className="hstack gap-2 justify-content-center mb-0">
                                    <button type="button" className="btn btn-soft-secondary" onClick={() => setDltModal(0)}>Close</button>
                                    <button type="button" className={`btn btn-danger`} onClick={() => handleDeleteBlog()}>Delete</button>

                                </div>
                            </ModalBody>
                        </div>
                    </Modal>
                    <CustomLoader isOpen={load} />
                    <CustomToaster message={apiResMsg} color={'text-success'} toast={toast} setToast={setToast} customTime={1000} />
                </Container>
            </Form>
        </div >
    )
}

export default BlogCreateEdit